"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Given an item from client storage, try to convert into null/object/etc
 * @param {*} item
 */

var parseItem = function parseItem(item) {
  var value;

  switch (true) {
    // if the item is the string 'null'...
    case item === 'null':
      // ...return actual null
      value = null;
      break;
    // if the item is a string...

    case typeof item === 'string':
      {
        // try to parse as JSON...
        try {
          var itemAsObject = JSON.parse(item); // ...if the parse succeeds, return the object

          value = itemAsObject;
        } catch (err) {
          // ...if the parse throws (invalid json), return the item
          value = item;
        }

        break;
      }

    default:
      // if we cannot determine type, just return the item
      value = item;
  }

  return value;
};

var _default = parseItem;
exports.default = _default;